import Status from "../../common/badges/Status/Status";
import { EntityDetailTableProps } from "../../common/entity/EntityInterfaces";
import { toUppercase } from "../../common/helperfunctions/stringFunctions";
import { LinkEntity } from "../../common/misc/LinkEntity/LinkEntity";
import { NotAvailable, NotSet } from "../../common/misc/UIconstants";
import { Table } from "../../common/panels/Detail/DetailTable";
import { labNoteBooksConstants } from "../types/LabNotebook";
import { LabNotebookExperimentStatus } from "../types/LabNotebookExperiment";

export const LabNotebookExperimentStatusToLabel = (status: LabNotebookExperimentStatus) => {
  switch (status) {
    case "FAILED":
      return { label: "Failed", status: "danger" };
    case "PAUSED":
      return { label: "Paused", status: "warning" };
    case "RUNNING":
      return { label: "Running", status: "success" };
    case "COMPLETED":
      return { label: "Completed", status: "success" };
    case "ABORTED":
      return { label: "Aborted", status: "danger" };

    default:
      return { label: "-", status: "warning" };
  }
};

export const LabNotebookExperimentDetailContentTable = ({
  entity,
  entityConstants,
  fieldLabels,
}: EntityDetailTableProps<"notebookExperiments">) => {
  return (
    <Table noPadding>
      <Table.Head>{toUppercase(entityConstants.entitySingular)} details</Table.Head>
      <Table.Body>
        <Table.Body.RowContent
          title={fieldLabels.labNotebook}
          content={<LinkEntity entityConstants={labNoteBooksConstants} property={entity.labNotebook} />}
        />

        <Table.Body.RowContent
          title={fieldLabels.name}
          content={
            <div className="container_label">
              <div className="container_label_name" style={{ fontWeight: 600 }}>
                {entity.name ?? NotSet}
              </div>
              <div className="container_label_id">
                <span style={{ whiteSpace: "nowrap" }}>
                  {toUppercase(entityConstants.entitySingular)}-ID: {entity.id ?? NotAvailable}
                </span>
              </div>
            </div>
          }
        />

        <Table.Body.RowContent
          title={fieldLabels.description}
          content={
            entity.description ? (
              <div className={"container_notes"}>
                <textarea rows={2} className={"container_textarea"} value={entity.description} disabled={true} />
              </div>
            ) : (
              NotSet
            )
          }
        />

        <Table.Body.RowContent
          title={fieldLabels.status}
          content={
            <div className="flex align-center gap-5">
              <Status
                idle={entity.status === "RUNNING"}
                type={LabNotebookExperimentStatusToLabel(entity.status).status as any}
              />
              {LabNotebookExperimentStatusToLabel(entity.status).label}
            </div>
          }
        />
      </Table.Body>
    </Table>
  );
};
